export const MAIN_MENU_DEFAULT_WIDTH        = 225
export const MAIN_MENU_POPOVER_MIN_WIDTH    = 255


export const BUS_NAVIGATION_CHANGED   = 'navigation:settings-changed'